import React from 'react'
import {
    Col,
    Row,
    Form
} from 'react-bootstrap'

import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class TypePerson extends React.Component {
    render() {

        // const { formState: { errors }, handleSubmit, register, trigger, watch } = useForm({ mode: 'onChange' })

        return (

            <>

                {this.props.type_person === 1 ? (

                    <>
                        <Row className='mb-3'>
                            {
                                this.props.id ? (
                                    <Col lg={1}>
                                        <Form.Group>
                                            <Form.Label htmlFor='co_id'>Código</Form.Label>
                                            <Form.Control type='text' id='co_id' name='co_id' value={this.props.id} readOnly max={10} maxLength={10} />
                                        </Form.Group>
                                    </Col>
                                ) : null
                            }

                            <Col lg={3}>
                                <Form.Label htmlFor='cpf'>CPF</Form.Label>
                                <Form.Group className='input-group'>
                                    <Form.Control
                                        type='text'
                                        className='flex-grow-1'
                                        id='cpf'
                                        name='cpf'
                                        placeholder='Informe o CPF'
                                        readOnly={this.props.id ? true : false}
                                    // register={register({
                                    //     required: {
                                    //         value: true,
                                    //         message: 'CPF é obrigatório',
                                    //     },
                                    //     pattern: {
                                    //         value: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/i,
                                    //         message: 'CPF inválido',
                                    //     },
                                    // })}
                                    />
                                    {!this.props.id ? (
                                        <button
                                            className='btn btn-primary'
                                            // onClick={(e) => searchCpf()}
                                            type='button'
                                        >
                                            <FontAwesomeIcon icon={faSearch} className='me-2' /> Buscar
                                        </button>
                                    ) : null}
                                </Form.Group>
                            </Col>

                            <Col lg={this.props.id ? 8 : 9}>
                                <Form.Group>
                                    <Form.Label htmlFor='name'>Nome</Form.Label>
                                    <Form.Control type='text' id='name' name='name' placeholder='Informe o nome do cliente' readOnly />
                                </Form.Group>
                            </Col>
                        </Row>
                    </>

                ) : null}

                {this.props.type_person === 2 ? (

                    <>
                        <Row className='mb-3'>
                            {
                                this.props.id ? (
                                    <Col lg={1}>
                                        <Form.Label htmlFor='co_id'>Código</Form.Label>
                                        <Form.Control type='text' id='co_id' name='co_id' value={this.props.id} readOnly max={10} maxLength={10} />
                                    </Col>
                                ) : null
                            }

                            <Col lg={3}>
                                <Form.Label htmlFor='cnpj'>CNPJ</Form.Label>
                                <Form.Group className='input-group'>
                                    <Form.Control className='flex-grow-1' type='text' id='cnpj' name='cnpj' placeholder='Informe o CNPJ' readOnly={this.props.id ? true : false} />
                                    {!this.props.id ? (
                                        <button
                                            className='btn btn-primary'
                                            type='button'
                                        >
                                            <FontAwesomeIcon icon={faSearch} className='me-2' /> Buscar
                                        </button>
                                    ) : null}
                                </Form.Group>
                            </Col>

                            <Col lg={this.props.id ? 8 : 9}>
                                <Form.Group>
                                    <Form.Label htmlFor='name'>Razão Social</Form.Label>
                                    <Form.Control type='text' id='name' name='name' placeholder='Informe o nome do cliente' readOnly={this.props.id ? true : false} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={7}>
                                <Form.Group>
                                    <Form.Label htmlFor='cnpj'>Nome Fantasia</Form.Label>
                                    <Form.Control type='text' id='cnpj' name='cnpj' placeholder='Informe o nome fantasia' readOnly={this.props.id ? true : false} />
                                </Form.Group>
                            </Col>

                            <Col lg={5}>
                                <Form.Group>
                                    <Form.Label htmlFor='name'>Responsável</Form.Label>
                                    <Form.Control type='text' id='name' name='name' placeholder='Informe o responsável' />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={5}>
                                <Form.Label htmlFor='cnpj'>Inscrição Estadual</Form.Label>
                                <Form.Group className='input-group'>
                                    <Form.Control type='text' id='cnpj' name='cnpj' placeholder='Informe o nome fantasia' />
                                    <span className="input-group-text">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" />
                                            <label className="form-check-label" for="flexSwitchCheckChecked">Isento</label>
                                        </div>
                                    </span>
                                </Form.Group>
                            </Col>

                            <Col lg={5}>
                                <Form.Group>
                                    <Form.Label htmlFor='name'>Inscrição Municipal</Form.Label>
                                    <Form.Group className='input-group'>
                                        <Form.Control type='text' id='cnpj' name='cnpj' placeholder='Informe o nome fantasia' />
                                        <span className="input-group-text">
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" />
                                                <label className="form-check-label" for="flexSwitchCheckChecked">Isento</label>
                                            </div>
                                        </span>
                                    </Form.Group>
                                </Form.Group>
                            </Col>
                        </Row>
                    </>

                ) : null}

            </>

        )
    }
}

export default TypePerson;




